// extracted by mini-css-extract-plugin
export var activeFilterButton = "_oe-c";
export var backButton = "_oe-4";
export var backIcon = "_oe-5";
export var chevronShortcut = "_oe-6";
export var container = "_oe-1";
export var editor = "_oe-8";
export var editorWrapper = "_oe-7";
export var prefix = "_oe-2";
export var searchIcon = "_oe-3";
export var suffix = "_oe-9";
export var suffixContent = "_oe-a";
export var suffixText = "_oe-b";
export var wrapper = "_oe-0";